var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHungupCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8574 9.20716L23.4668 6.2419C23.7041 6.00468 23.6448 5.58954 23.4668 5.41163C20.5016 2.32776 17.3584 0.13347 11.9023 0.133469C6.44626 0.133468 3.59962 2.38706 0.575054 5.41162C0.337834 5.64884 0.337833 6.00468 0.575054 6.2419L3.18448 9.20716C3.4217 9.44438 3.77753 9.44438 4.01475 9.32577L7.21723 6.95356C7.33584 6.83495 7.51376 6.65703 7.45445 6.47912C7.45445 5.17441 7.45445 4.22552 7.51376 3.929C7.92889 3.75108 9.47083 3.15803 11.9023 3.21734C14.2745 3.21734 16.0537 3.81039 16.5281 3.929C16.5281 4.40344 16.5281 5.47093 16.5281 6.41982C16.5281 6.65704 16.6468 6.77565 16.7654 6.89426L20.0271 9.32577C20.2051 9.50368 20.6202 9.44438 20.8574 9.20716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHungupCall);
export default __webpack_public_path__ + "static/media/icon-hungup-call.4e5d820e696c0ed550e7aa65cc75a36f.svg";
export { ForwardRef as ReactComponent };